import { connect } from 'react-redux';
import type { IReduxState } from '../../../../../configureStore';
import type { ValidationErrors } from '../../../../../utils/validation';
import type { IRequest } from '../../../../interfaces/request';
import type { IServiceGetOne } from '../../../../interfaces/serviceGetOne';
import type { IRequestAddEdit } from '../../../requests/RequestItemAddEdit';
import { translateKey } from '../../../../../translate';
import { ServiceOrganizationConsumerSelection } from '../../../../elements/ServiceOrganizationConsumerSelection';

interface IServiceConsumerSupervisorSelectorProps {
    errors: ValidationErrors;
    handleChange: <K extends keyof IRequestAddEdit>(name: K, value: IRequestAddEdit[K]) => Promise<void>;
    request: IRequest;
    service: IServiceGetOne;
    validateOne: (name: keyof IRequestAddEdit) => Promise<void>;
}

interface IServiceConsumerSupervisorSelectorReduxPropsState {
    needsSupervisor: boolean;
    organizationId: string;
    practitionerId: string;
}

const mapStateToProps = ({ authentication }: IReduxState): IServiceConsumerSupervisorSelectorReduxPropsState => ({
    organizationId: authentication.organizationId,
    practitionerId: authentication.id,
    needsSupervisor: authentication.needsSupervisor,
});

function InnerServiceConsumerSupervisorSelector(
    props: IServiceConsumerSupervisorSelectorProps & IServiceConsumerSupervisorSelectorReduxPropsState
) {
    if (!props.needsSupervisor) {
        if (props.request.supervisorPractitionerId) {
            props.handleChange('supervisorPractitionerId', undefined);
        }

        return null;
    }

    return (
        <ServiceOrganizationConsumerSelection
            error={props.errors.get('supervisorPractitionerId')}
            excludePractitionerId={props.practitionerId}
            hasErrors={props.errors.has('supervisorPractitionerId')}
            initialOrganizationId={props.request.supervisorPractitionerId ? props.organizationId : null}
            initialPractitionerId={props.request.supervisorPractitionerId || null}
            isSupervisorSelector={true}
            label={translateKey('request.supervisedBy')}
            onChange={async (organizationId, practitionerId) => {
                await props.handleChange('supervisorPractitionerId', practitionerId || undefined);
            }}
            onDoValidate={async () => {
                await props.validateOne('supervisorPractitionerId');
            }}
            requesterOrganizationId={props.organizationId}
            serviceId={props.service.id}
        />
    );
}

export const ServiceConsumerSupervisorSelector = connect(mapStateToProps)(InnerServiceConsumerSupervisorSelector);
